const initState = {
    accessToken: {},
    idToken: {},
};

export const UPDATE_TOKENS = 'UPDATE_TOKENS';

export const updateTokens = ({ accessToken, idToken }) => {
    return { type: UPDATE_TOKENS, accessToken, idToken };
};

export default (state = initState, action) => {
    switch (action.type) {
        case UPDATE_TOKENS:
            return {
                ...state,
                accessToken: action.accessToken,
                idToken: action.idToken,
            };
        default:
            return state;
    }
};
